import { Map } from 'immutable';

export const pltabReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'PUT_PL_ROW': {
      const previuosValue = state.getIn([action.elementId, 'expenses']
        .concat(action.groupId || ['deal'])
        .concat([action.field]));
      if (previuosValue && action.value &&
         JSON.stringify(previuosValue) == JSON.stringify(action.value)) {
        return state;
      }
      return state.setIn([action.elementId, 'expenses']
        .concat(action.groupId || ['deal'])
        .concat([action.field]),
      { ...previuosValue, ...action.value });
    }
    case 'PUT_PL_TOTAL':
      return state.setIn([action.elementId, 'total', action.totalType], action.value);
    case 'PUT_PL_ERROR':
      return state.setIn(['error', action.productId], action.message);
    case 'CLEAR_PL_ERROR':
      return state.deleteIn(['error', action.productId]);
    case 'CLEAR_DEAL':
    case 'DEAL_LOADED':
    case 'LOGOUT':
      return new Map();
    default:
      return state;
  }
};
export const putPLRow = (dispatch, field, value, elementId, groupId) => {
  dispatch({ type: 'PUT_PL_ROW', field, value, elementId, groupId });
};
export const putPLTotal = (dispatch, elementId, totalType, value) => {
  dispatch({ type: 'PUT_PL_TOTAL', elementId, totalType, value });
};
export const putPLError = (dispatch, productId, message) =>
  dispatch({ type: 'PUT_PL_ERROR', productId, message });

export const clearPLError = (dispatch, productId) =>
  dispatch({ type: 'CLEAR_PL_ERROR', productId });
